import { z } from "zod";

export const notificationChannelSchema = z.object({
  name: z.string().trim().min(1).max(80),
  type: z.enum(["wechat_work", "webhook", "sms_http"]),
  endpoint: z.string().trim().url("请输入有效 URL").max(2000).optional().nullable(),
  token: z.string().max(2000).optional().nullable(),
  recipients: z.array(z.string().trim().min(1).max(50)).max(200).default([]),
  events: z.array(z.string().trim().min(1).max(100)).min(1).max(50),
  enabled: z.boolean().default(true),
});

export const NOTIFICATION_EVENTS = [
  { code: "request.created", label: "申请待审批" },
  { code: "request.decided", label: "申请通过/拒绝" },
  { code: "handover.created", label: "交接待确认" },
  { code: "*", label: "全部事件" },
] as const;
